import { useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';

import { apiGetFleets } from '../../../api/services/fleetApi';
import type { FleetRecord } from '../../../types';

type Step3Props = {
  selectedVehicleId: string | null;
  onSelectVehicle: (id: string) => void;
};

export const Step3VehicleSelection = ({
  selectedVehicleId,
  onSelectVehicle,
}: Step3Props) => {
  const [vehicles, setVehicles] = useState<FleetRecord[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadVehicles = async () => {
      try {
        console.log('LOADING REAL VEHICLES FROM API...');

        const response = await apiGetFleets();

        console.log('REAL VEHICLE API RESPONSE:', response);

        if (response.success && response.data) {
          setVehicles(response.data);
        } else {
          console.error('Vehicle API failed:', response.message);
        }
      } catch (error) {
        console.error('Vehicle loading error:', error);
      } finally {
        setLoading(false);
      }
    };

    loadVehicles();
  }, []);

  if (loading) {
    return (
      <div className="flex justify-center items-center py-20">
        <Loader2
          size={32}
          className="animate-spin text-[#FF6A1A]"
        />
      </div>
    );
  }

  return (
    <div className="flex flex-col w-full max-w-[1000px] mx-auto px-[32px]">
      {vehicles.length === 0 ? (
        <div className="text-center py-20">
          <p className="text-[16px] font-bold">
            No vehicles found.
          </p>
          <p className="text-[14px] text-gray-500 mt-2">
            Add a vehicle from Vehicle Management.
          </p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {vehicles.map((vehicle) => {
            const isSelected =
              selectedVehicleId === String(vehicle.id);

            return (
              <div
                key={vehicle.id}
                onClick={() =>
                  onSelectVehicle(String(vehicle.id))
                }
                className={`flex flex-col rounded-[20px] overflow-hidden cursor-pointer border-2 transition-all ${
                  isSelected
                    ? 'border-[#FF6A1A]'
                    : 'border-transparent hover:border-[#E0E0E0]'
                }`}
              >
                <div className="relative w-full h-[160px] bg-[#B2D27D] flex items-center justify-center pt-8">
                  <div className="absolute top-4 left-4 inline-flex items-center gap-2 rounded-full bg-black/10 px-3 py-1.5">
                    <span
                      className={`w-2.5 h-2.5 rounded-full ${
                        isSelected
                          ? 'bg-white'
                          : 'bg-[#9E9E9E]'
                      }`}
                    />

                    <span className="font-host text-[12px] font-medium text-black">
                      {vehicle.category || 'Vehicle'}
                    </span>
                  </div>

                  {vehicle.image ? (
                    <img
                      src={vehicle.image}
                      alt={vehicle.name}
                      className="w-full h-auto max-h-[120px] object-contain drop-shadow-xl scale-110 translate-y-4"
                    />
                  ) : (
                    <span className="text-sm text-gray-500">
                      No image
                    </span>
                  )}
                </div>

                <div className="w-full bg-[#EAEAEA] py-4 flex flex-col items-center justify-center">
                  <span className="font-host text-[15px] font-bold text-[#1A1A1A]">
                    {vehicle.name}
                  </span>

                  <span className="font-host text-[12px] text-gray-500 mt-1">
                    {vehicle.plate}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};